(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Logo-de-marcas"] && !Shopify.designMode) return;
  try {
    
(() => {
  try{
    const wrap = document.querySelector('.brand-logos-wrapper');
    const list = wrap?.querySelector('#brand-logos-list');
    if(!wrap || !list) return;

    const prevBtn = wrap.querySelector('.owl-prev');
    const nextBtn = wrap.querySelector('.owl-next');
    const STEP = 260;

    /* -------- helpers -------- */
    const setActiveItem = (item) => {
      // desativa todos, mantém só o atual
      list.querySelectorAll('.brand-logo-item.show-name').forEach(el=>{
        if(el !== item) el.classList.remove('show-name');
      });
      if(item) item.classList.add('show-name');
    };

    const sync = () =>{
      const atStart = list.scrollLeft <= 0;
      const atEnd   = list.scrollLeft >= (list.scrollWidth - list.clientWidth - 1);
      if (prevBtn){
        prevBtn.classList.toggle('disabled', atStart);
        prevBtn.setAttribute('aria-hidden', atStart ? 'true' : 'false');
      }
      if (nextBtn){
        nextBtn.classList.toggle('disabled', atEnd);
        nextBtn.setAttribute('aria-hidden', atEnd ? 'true' : 'false');
      }
    };

    /* -------- imagens (fade-in) -------- */
    list.querySelectorAll('img').forEach(img=>{
      if (img.complete) img.classList.add('loaded');
      else img.addEventListener('load',()=>img.classList.add('loaded'), {once:true});
    });

    /* -------- setas -------- */
    sync();
    list.addEventListener('scroll', sync);
    window.addEventListener('resize', sync);

    prevBtn?.addEventListener('click',()=>{
      if(prevBtn.classList.contains('disabled')) return;
      list.scrollBy({left:-STEP,behavior:'smooth'});
    });
    nextBtn?.addEventListener('click',()=>{
      if(nextBtn.classList.contains('disabled')) return;
      list.scrollBy({left: STEP,behavior:'smooth'});
    });

    /* -------- drag com mouse -------- */
    let isDown=false,startX=0,startLeft=0, dragged=false;
    list.addEventListener('mousedown',(e)=>{
      isDown=true; dragged=false;
      list.classList.add('is-dragging');
      startX=e.pageX; startLeft=list.scrollLeft;
    });
    ['mouseup','mouseleave'].forEach(ev=>{
      list.addEventListener(ev,()=>{
        isDown=false; list.classList.remove('is-dragging');
        // pequeno debounce para não contar drag como clique
        setTimeout(()=>{ dragged=false; }, 0);
      });
    });
    list.addEventListener('mousemove',(e)=>{
      if(!isDown) return;
      e.preventDefault();
      const walk=(e.pageX-startX)*1.2;
      if(Math.abs(walk) > 5) dragged=true;
      list.scrollLeft=startLeft-walk;
    });

    /* -------- roda do mouse vira scroll horizontal -------- */
    list.addEventListener('wheel',(e)=>{
      const absY=Math.abs(e.deltaY), absX=Math.abs(e.deltaX);
      if(absY>absX){
        e.preventDefault();
        list.scrollLeft += e.deltaY;
      }
    }, {passive:false});

    /* -------- glow temporário ao qualquer clique/tap dentro da lista -------- */
    list.addEventListener('click',e=>{
      const target = e.target.closest?.('a,span');
      if(!target) return;
      wrap.classList.add('bar-glow');
      clearTimeout(wrap._glowTimer);
      wrap._glowTimer = setTimeout(()=>wrap.classList.remove('bar-glow'),800);
    });

    /* ===== lógica de 1º clique (revela) / 2º clique (navega) =====
       + congela o pulso do glow por um instante
    */
    const ARM_WINDOW = 2000;  // janela para segundo clique navegar
    const HOLD_MS    = 900;   // tempo do glow congelado

    const armLink = (a) => {
      a.dataset.armed = '1';
      clearTimeout(a._armTimer);
      a._armTimer = setTimeout(()=>{ a.dataset.armed = '0'; }, ARM_WINDOW);

      // ativa apenas o item clicado
      const item = a.closest('.brand-logo-item');
      setActiveItem(item);

      // congela pulso
      wrap.classList.add('glow-hold','bar-glow');
      clearTimeout(wrap._holdTimer);
      wrap._holdTimer = setTimeout(()=>{
        wrap.classList.remove('glow-hold');
        clearTimeout(wrap._glowTimer);
        wrap._glowTimer = setTimeout(()=>wrap.classList.remove('bar-glow'), 300);
      }, HOLD_MS);
    };

    // delegação de clique só para links
    list.addEventListener('click', (e)=>{
      // se houve drag, ignora clique
      if (dragged) return;

      const a = e.target.closest('a');
      if(!a) return;

      const item = a.closest('.brand-logo-item');

      // 1º clique: só arma e impede navegação
      if(a.dataset.armed !== '1'){
        e.preventDefault();
        armLink(a);
        return;
      }

      // 2º clique: navega e mantém só este ativo
      setActiveItem(item);
      a.dataset.armed = '0';
    });

    /* Enter pelo teclado deve navegar direto (acessibilidade) */
    list.addEventListener('keydown', (e)=>{
      if(e.key !== 'Enter') return;
      const a = e.target.closest?.('a');
      if(!a) return;
      const item = a.closest('.brand-logo-item');
      setActiveItem(item);
      a.dataset.armed = '0';
      // deixa o navegador seguir o link normalmente
    });

    /* clique fora do slider: limpa o "armado" e os nomes ativos (opcional) */
    document.addEventListener('click', (e)=>{
      if (wrap.contains(e.target)) return;
      list.querySelectorAll('a[data-armed="1"]').forEach(a=>a.dataset.armed='0');
      list.querySelectorAll('.brand-logo-item.show-name').forEach(el=>el.classList.remove('show-name'));
    });

    /* garante visualização do gutter */
    wrap.style.overflow = 'visible';
  }catch(err){
    console && console.warn && console.warn('[Brand Logos Slider] erro silenciado:', err);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
